import axios from "axios";

const BASE_URLS = {
  login: {
    dev: "https://testauth.paylayercore.com/api/v1/auth/login",
    prod: "https://auth.trpayz.com/api/v1/auth/login",
  },
  transaction: {
    dev: "https://testpayman.paylayercore.com/api/v1/company/transaction",
    prod: "https://api.trpayz.com/api/v1/company/transaction",
  },
  paymentMethod: {
    dev: "https://testpayman.paylayercore.com/api/v1/enum/paymentmethod",
    prod: "https://api.trpayz.com/api/v1/enum/paymentmethod",
  }
};

const isProduction = process.env.NODE_ENV === "production";

console.log(`Current Environment: ${isProduction ? 'Production' : 'Development'}`);

export const loginUser = async (email, password, rememberMe) => {
  try {
    const response = await axios.post(
      isProduction ? BASE_URLS.login.prod : BASE_URLS.login.dev,
      { email, password }
    );

    console.log("Login successful:", response.data);

    const accessToken = response.data.accessToken;

    if (rememberMe) {
      localStorage.setItem("accessToken", accessToken);
    } else {
      sessionStorage.setItem("accessToken", accessToken);
    }

    return { success: true, data: response.data };
  } catch (err) {
    console.error("Login error:", err);
    let errorMessage = "Something went wrong. Please try again.";
    if (err.response?.data?.message) {
      errorMessage = err.response.data.message;
    }
    return { success: false, message: errorMessage };
  }
};

export const getTransaction = async (queryParams = {}) => {
  try {
    const accessToken =
      localStorage.getItem("accessToken") || sessionStorage.getItem("accessToken");

    if (!accessToken) {
      throw new Error("No access token found");
    }

    const transactionUrl = isProduction
      ? BASE_URLS.transaction.prod
      : BASE_URLS.transaction.dev;

    const response = await axios.get(transactionUrl, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      params: queryParams, 
    });

    console.log("Get transaction successful:", response.data);
    return { success: true, data: response.data };
  } catch (err) {
    console.error("Get transaction error:", err);
    let errorMessage = "Something went wrong. Please try again.";
    if (err.response?.data?.message) {
      errorMessage = err.response.data.message;
    }
    return { success: false, message: errorMessage };
  }
};


export const getPaymentMethosds = async () => {
    try {
      const accessToken =
        localStorage.getItem("accessToken") ||
        sessionStorage.getItem("accessToken");
  
      if (!accessToken) {
        throw new Error("No access token found");
      }
      const paymentMethodUrl = isProduction
      ? BASE_URLS.paymentMethod.prod
      : BASE_URLS.paymentMethod.dev;

      const response = await axios.get(paymentMethodUrl, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
  
      console.log("Get payment methods successful:", response.data);
      return { success: true, data: response.data };
    } catch (err) {
      console.error("Get payment methods error:", err);
      let errorMessage = "Something went wrong. Please try again.";
      if (err.response && err.response.data && err.response.data.message) {
        errorMessage = err.response.data.message;
      }
      return { success: false, message: errorMessage };
    }
  };

export const signOut = () => {
  localStorage.removeItem("accessToken");
  sessionStorage.removeItem("accessToken");

  window.location.href = "/";
};
